import React, {Component} from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';

import {colors} from 'style';

const s = {
    backgroundColor: colors.pointsYellow,
    border: '2px solid #fff',
    boxShadow: '2px 0px 2px rgba(0,0,0,0.2)',
    borderRadius: '10px',
    height: '40px',
    width: '250px',
    textAlign: 'center',
    lineHeight: '35px',
    fontSize: '0.95em',
}

const millisecondsPerDay = 1000*60*60*24;

class TimeRemainingLabel extends Component {
    constructor(props) { 
        super(props);
        this.state = {timeRemaining:null};
        this.timerId = null;
        this.tick = this.tick.bind(this);
        this.tickDuration = 1000;
    }

    componentWillMount() {
        this.start();
    }
    componentWillUnmount() {
        this.stop();
    }

    start() {
        if(this.timerId===null) {
            this.timerStartedAt= new Date().getTime();
            this.timerId = setInterval(this.tick, this.tickDuration);
            this.tick();
        }
    }
    stop() {
        if(this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }
    tick() {
        var nowDate = new Date();
        var now = nowDate.getTime();
        var utc = moment(this.props.endsAt).utc();
        var local = utc ? moment([utc.year(), utc.month(), utc.date()]) : nowDate;
        var timeRemaining = Math.max(0,local.toDate().getTime() - now);
        this.setState({timeRemaining:timeRemaining});
    }
    render() {
        var t = this.props.t;
        var time = this.state.timeRemaining || 0;
        var days = Math.floor(this.state.timeRemaining/millisecondsPerDay);
        time = time - days*millisecondsPerDay;
        return (
            <div style={{...s, ...this.props.style}}>
                {t('Time Remaining')} - {this.state.timeRemaining && (days+':'+moment(this.state.timeRemaining).utc().format('HH:mm:ss'))}
            </div>
        );
    }

}

export default translate('misc')(TimeRemainingLabel);



// WEBPACK FOOTER //
// ./src/modules/misc/TimeRemainingLabel.js